import { render, staticRenderFns } from "./LeadFunnelStepAgeRange.vue?vue&type=template&id=40d12b95&"
import script from "./LeadFunnelStepAgeRange.vue?vue&type=script&lang=js&"
export * from "./LeadFunnelStepAgeRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports